import Button from "../core/Button";
import GameConfig from "../core/data/GameConfig";
import Strings from "../core/data/Strings";
import ResizableScene from "../core/ResizableScene";
import ScaleManager from "../core/ScaleManager";
import F84Game from "../Game";
import { CharacterUnlockData } from "../game/MissionsState";
import { TapHand } from "../game/TapHand";
import PlayerData from "../PlayerData";
import { CharacterButton } from "../ui/CharacterButton";
import { StoreItem } from "../ui/StoreItem";
import Fonts from "../utils/Fonts";
import LayoutUtils from "../utils/LayoutUtils";
import { PlayerDataUtils } from "../utils/PlayerDataUtils";

export type ItemData = {
	price: number[];
	values: number[];
	color: string;
}

export default class ShopScene extends ResizableScene {
	itemsVisible: boolean;
	itemTab: Button;
	playerTab: Button;
	charButtons: CharacterButton[];
	boxes: StoreItem[];
	specialOffer: Phaser.GameObjects.Container;
	specialOfferIMG: Phaser.GameObjects.Image;
	// specialOfferText: Phaser.GameObjects.Text;
	// specialOfferDescText: Phaser.GameObjects.Text;
	shopContainer: Phaser.GameObjects.Container;

	playerTabHand: TapHand;
	characterButtonHand: TapHand;
	coinText: Phaser.GameObjects.Text;
	coinsBacker: Phaser.GameObjects.Image;
	costTween: Phaser.Tweens.Tween;
	coinContainer: Phaser.GameObjects.Container;
	coinsImg: Phaser.GameObjects.Image;

	static HIDE_COINS = "hideCoins";

    create(): void {
		this.itemsVisible = true;

		const bg = this.add.image(0, 0, "shopBaseBG");
		const backButton = this.add.button(0, 0, "shopBackBtn", undefined, this.back, this, true);

		const soundOn = !this.soundManager.muted;
		const soundButtonKey = soundOn ? "soundButtonOn" : "soundButtonOff";
		const soundButton = this.add.button(0, 0, soundButtonKey, undefined, () => this.toggleSound(soundButton), undefined, true);

		const playButton = this.add.button(0, 0, "shopPlayBtn", undefined, this.play, this, true);

		const header = this.add.container();

		const headerImg = this.add.button(0, 0, "shopHeader", undefined, () => {
			PlayerData.Instance.saveData.coins += 1000;
			PlayerData.Instance.save();
			this.resize();
		});
		if(!GameConfig.get("enableCoinsOnShopBacker")) headerImg.disableInteractive();
		header.setSize(headerImg.width, headerImg.height);

		const headerACME = this.add.image(0, 0, "shopHeaderACME");

		const catalogStr = Strings.get("Catalog");
		catalogStr.replace("%", "");
		const acmeLeft = catalogStr.indexOf("%") == 0;
		const headerText = this.add.text(0, 0, catalogStr.replace("%", ""), {
			fontFamily: Fonts.LuckiestGuy,
			fontSize: "76px",
			color: "#ffeddf",
			strokeThickness: 2,
			stroke: "#241b1a",
			shadow: {fill: true, color: "#58402a", offsetX: 5, offsetY: 6},
			padding: { bottom: 30, top: 30 }
		});
		LayoutUtils.scaleToMaxWidth(headerText, 350);
		headerText.setSize(headerText.displayWidth, headerText.displayHeight);

		header.add([headerImg, headerText, headerACME]);

		const coinContainer = this.coinContainer = this.add.container();
		const coinsBacker = this.coinsBacker = this.add.image(0, 0, "shopCoinCounter");
		const coinsImg = this.coinsImg = this.add.image(0, 0, "shopCoin");
		const coins = PlayerData.Instance.saveData.coins;
		const coinStr = coins.toLocaleString("en-US");
		const coinsAmount = this.coinText = this.add.text(0, 0, "", {
			fontFamily: Fonts.LuckiestGuy,
			fontSize: "63px",
			color: "#FBF6E7",
			align: "left"
		});
		coinsAmount.setText(coinStr + "");
		coinContainer.setSize(coinsBacker.width, coinsBacker.height);
		coinContainer.add([coinsBacker, coinsImg, coinsAmount]);

		const shopContainer = this.shopContainer = this.add.container();
		const leftGlow = this.add.image(0, 0, "shopBGGlow");
		const rightGlow = this.add.image(0, 0, "shopBGGlow");
		const itemTab = this.itemTab = this.add.button(0, 0, "shopTabItemActive", undefined, () => {
			this.showItems(true);
		}, this, false);
		const playerTab = this.playerTab = this.add.button(0, 0, "shopTabPlayerInactive", undefined, () => {
			this.showItems(false);
		}, this, false);
		const shopContainerBook = this.add.image(0, 0, "shopBook");
		shopContainer.setSize(shopContainerBook.width, shopContainerBook.height);
		shopContainer.add([leftGlow, rightGlow, itemTab, playerTab, shopContainerBook]);

		const items = ["rubberBand", "detonator", "grease", "steelBall", "anvil"];
		const boxes: StoreItem[] = this.boxes = [];
		let spawnedHand = false;
		for (let i = 0; i < 5; i++) {
			const item = new StoreItem(this, items[i]);
			boxes.push(item);
			shopContainer.add(item);

			const itemData = GameConfig.get<any>("items")[items[i]] as ItemData;
			const level = PlayerData.Instance.saveData.items[items[i]];
			const price = itemData.price[level];
			const canAfford = PlayerData.Instance.saveData.coins >= price;

			// we only need to spawn one shop hand, but we don't want to show it until item panel animation has finished
			if (canAfford && !PlayerData.Instance.saveData.boughtItem && !spawnedHand) { 
				spawnedHand = true;
				const shopTutHand = this.add.image(0, 0, "tutHand");
				shopTutHand.setOrigin(10 / shopTutHand.width, 100 / shopTutHand.height);
				shopTutHand.angle = 45;
				this.tweens.add({
					targets: shopTutHand,
					scale: 1.2,
					ease: Phaser.Math.Easing.Quadratic.Out,
					yoyo: true,
					duration: 500,
					loop: -1,
				});
				item.hand = shopTutHand;
				shopTutHand.visible = false;
			}

			item.on(StoreItem.ON_BUY_PRESSED, (itemName: string) => {
				this.buy(itemName, item);
				if(item.hand) { 
					item.hand.destroy();
					// if we also should be able to select a new character for the first time, display that tutorial hand now
					this.addPlayerTabHand();
				}
			});

			item.setScale(0);
		}

		LayoutUtils.alignGrid(this, boxes, shopContainer, { x: 785, y: 268 }, 2, 15, -20);
		boxes[4].x = boxes[0].x;
		boxes[4].divider.setVisible(false);

		const specialOfferContainer = this.specialOffer = this.add.container();
		shopContainer.add(specialOfferContainer);
		const specialOffer = this.specialOfferIMG = this.add.image(0, 0, "shopDeco");
		specialOfferContainer.setSize(specialOffer.width, specialOffer.height);
		specialOfferContainer.add([specialOffer]);

		const charButtonsBG = this.add.image(0, 0, "whiteSquare");
		charButtonsBG.tint = 0x888888;
		charButtonsBG.alpha = 0.001;
		charButtonsBG.setSize(700, 300);
		charButtonsBG.setDisplaySize(700, 300);
		const charButtons: CharacterButton[] = this.charButtons = [];
		const characters = GameConfig.get<CharacterUnlockData[]>("characterUnlocks");
		for (let i = 0; i < characters.length; i++) {
			let locked = (i > PlayerData.Instance.saveData.charactersUnlocked);
			if (GameConfig.get<boolean>("allCharactersUnlocked")) locked = false;
			const button = new CharacterButton(this, i, characters[i], locked, () => this.setCharacter(locked, i));
			shopContainer.add(button);
			charButtons.push(button);
			button.setVisible(false);
			button.angle = ((i % 2) == ((i % 4 < 2) ? 0 : 1)) ? -2.2 : 1;
		}
		shopContainer.add( playButton);

		this.addResize((): void => {
			const coins = PlayerData.Instance.saveData.coins.toLocaleString("en-US");
			coinsAmount.setText(coins + "");
            ScaleManager.ScaleBackgroundFromZone(bg, this.viewport);
			this.alignIn.Center(bg, this.viewport);
			this.alignTo.TopLeft(itemTab, shopContainerBook, itemTab.width - 50, -itemTab.height - 40);
			this.alignTo.BottomCenter(playerTab, itemTab, 5, 0);
			this.alignIn.TopLeft(backButton, this.viewport, -34, -34);
			this.alignIn.TopCenter(header, this.viewport, 0, -20);
			const headerArray = [headerText, headerACME];
			if(acmeLeft) headerArray.reverse();
			LayoutUtils.alignHorizontally(this, headerArray, headerImg, 25);
			// Kludge - alignHorizontally isn't vertically centering correctly
			switch(F84Game.Instance.locale)
			{
				case "de-de":
					headerText.y -= 10;
					break;
				case "es-es":
					headerText.y -= 5;
					break;
				case "es-mx":
					headerText.y -= 5;
					break;
				case "en-us":
					headerText.y -= 10;
					break;
				case "fr-fr":
					headerText.y -= 5;
					break;
				case "it-it":
					headerText.y -= 10;
					break;
				case "ja-jp":
					headerText.y -= 10;
					break;
				case "ko-ko":
					headerText.y -= 10;
					break;
				case "pt-br":
					headerText.y -= 5;
					break;
				case "zh-cn":
					headerText.y -= 10;
				case "ru-ru":
					headerText.y -= 4;
				case "pl-pl":
					headerText.y -= 4;
				case "ar-ar":
					headerText.y -= 15;
			}
			this.alignIn.TopRight(soundButton, this.viewport, -34, -34);
			const scale = Math.min(this.viewport.width / 1920, 1);
			shopContainer.scale = scale;
			this.alignIn.Center(shopContainer, this.viewport, 30, 74);
			this.alignIn.Center(leftGlow, shopContainerBook, -500, 0);
			this.alignIn.Center(rightGlow, shopContainerBook, 400, 0);
			this.alignIn.BottomRight(charButtonsBG, shopContainer, -50, -100);
			this.alignIn.BottomRight(specialOfferContainer, shopContainerBook, -240, -120);
			// this.alignIn.LeftCenter(specialOfferText, specialOffer, -420, -50);
			// this.alignIn.LeftCenter(specialOfferDescText, specialOffer, -273, 40);
			this.alignIn.BottomRight(playButton, shopContainerBook, 50, -20);
			if (scale < 0.86) this.alignIn.TopRight(coinContainer, this.viewport, -34, -130);
			else this.alignTo.LeftCenter(coinContainer, soundButton, 20, 0);
			this.alignIn.Center(coinsAmount, coinsBacker, (coinsAmount.width/2) - 10, -5);
			this.alignIn.LeftCenter(coinsImg, coinsBacker, -20, 0);
			this.resizeCoinText();

			this.boxes.forEach(b => b.updateLayout());

			const charsPage1 = charButtons.slice(0, 6);
			const charsPage2 = charButtons.slice(6);
			LayoutUtils.alignGrid(this, charsPage1, shopContainerBook, { x: 350, y: 255 }, 2,  -400, -45);
			LayoutUtils.alignGrid(this, charsPage2, shopContainerBook, { x: 350, y: 255 }, 2, 380, -170);
			this.charButtons.forEach(b => b.updateLayout());
        });

        this.resize();

        super.create();

		// Initial tween in ----------
		shopContainer.y += this.viewport.height;
		itemTab.x += 500;
		playerTab.x += 500;
		header.y -= 500;
		backButton.setScale(0);
		soundButton.setScale(0);
		playButton.setScale(0);
		coinContainer.setScale(0);
		leftGlow.setScale(0);
		rightGlow.setScale(0);
		const timeline = this.tweens.createTimeline();
		timeline.add({
			targets: shopContainer,
			y: shopContainer.y - this.viewport.height,
			duration: 200,
			ease: Phaser.Math.Easing.Back.Out,
			delay: 500,
		});

		this.time.addEvent({
			delay: 400,
			callback: () => {
				this.showItems(true);
				// this.tweens.add({
				// 	targets: specialOfferContainer,
				// 	scale: 1,
				// 	duration: 100,
				// 	delay: 200,
				// 	ease: Phaser.Math.Easing.Back.Out,
				// });
			}
		})

		timeline.add({
			targets: itemTab,
			x: itemTab.x - 500,
			duration: 300,
			ease: Phaser.Math.Easing.Quadratic.Out,
			onStart: () => {
				this.tweens.add({
					targets: playerTab,
					x: playerTab.x - 500,
					duration: 300,
					ease: Phaser.Math.Easing.Quadratic.Out,
				});

				this.tweens.add({
					targets: header,
					y: header.y + 500,
					duration: 300,
					ease: Phaser.Math.Easing.Quadratic.Out,
				});

				this.tweens.add({
					targets: [backButton, soundButton, playButton, coinContainer, leftGlow, rightGlow],
					scale: 1,
					duration: 300,
					ease: Phaser.Math.Easing.Back.Out,
				});
			}
		});

		timeline.play();
	}
	
	shutdown(): void {
        super.shutdown();
	}

	showItems(items: boolean): void {
		this.itemsVisible = items;
		if (items) {
			this.itemTab.disableInteractive();
			this.playerTab.disableInteractive();
			this.dismissCharacterButtonHand();
			this.tweens.add({
				targets: this.itemTab,
				scale: 0.9,
				duration: 100,
				ease: Phaser.Math.Easing.Quadratic.In,
				onComplete: () => {
					this.itemTab.setTexture("shopTabItemActive");
					this.playerTab.setTexture("shopTabPlayerInactive");
					this.playerTab.setInteractive();
					this.tweens.add({
						targets: this.itemTab,
						scale: 1,
						duration: 150,
						ease: Phaser.Math.Easing.Back.Out,
					});
				}
			});
			
			for (let i = this.charButtons.length - 1; i >= 0; i--) {
				const button = this.charButtons[i];
				this.tweens.killTweensOf(button);
				button.scale = 1;
				this.tweens.add({
					targets: button,
					scale: 0,
					ease: Phaser.Math.Easing.Back.In,
					duration: 200,
					delay: 25 * (this.charButtons.length - i),
					onComplete: () => button.setVisible(false),
				});
			}
			for (let i = this.boxes.length - 1; i >= 0; i--) {
				const item = this.boxes[i];
				this.tweens.killTweensOf(item);
				item.scale = 0;
				this.tweens.add({
					targets: item,
					scale: 1,
					ease: Phaser.Math.Easing.Back.Out,
					duration: 200,
					delay: 50 * (this.boxes.length - i) + 25 * (this.charButtons.length),
					onComplete: ()=> {
						if(item.hand) item.hand.visible = true;
						if(i == 0) this.addPlayerTabHand();
					}
				});
				item.setVisible(true)
			}
		} else {
			this.events.emit(ShopScene.HIDE_COINS);
			this.itemTab.disableInteractive();
			this.playerTab.disableInteractive();
			this.dismissPlayerTabHand();
			this.tweens.add({
				targets: this.playerTab,
				scale: 0.9,
				duration: 100,
				ease: Phaser.Math.Easing.Quadratic.In,
				onComplete: () => {
					this.itemTab.setTexture("shopTabItemInactive");
					this.itemTab.setInteractive();
					this.playerTab.setTexture("shopTabPlayerActive");
					this.tweens.add({
						targets: this.playerTab,
						scale: 1,
						duration: 150,
						ease: Phaser.Math.Easing.Back.Out,
					});
				}
			});
			
			for (const item of this.boxes) {
				this.tweens.killTweensOf(item);
				item.scale = 1;
				if(item.hand) item.hand.visible = false;
				this.tweens.add({
					targets: item,
					scale: 0,
					ease: Phaser.Math.Easing.Back.In,
					duration: 200,
					delay: 50 * this.boxes.findIndex(b => b == item),
					onComplete: () => item.setVisible(false),
				});
			}
			for (const button of this.charButtons) {
				const buttonIndex = this.charButtons.findIndex(b => b == button)
				this.tweens.killTweensOf(button);
				button.scale = 0;
				this.tweens.add({
					targets: button,
					scale: 1,
					ease: Phaser.Math.Easing.Back.Out,
					duration: 200,
					delay: 25 * buttonIndex + 50 * (this.boxes.length),
					onComplete: ()=> {
						if(buttonIndex == this.charButtons.length - 1) this.addCharacterButtonHand();
					}
				});
				button.setVisible(true)
			}
		}
	}

	addPlayerTabHand(): void {
		this.dismissPlayerTabHand();
		if(PlayerDataUtils.CanUnlockFirstCharacter() && PlayerData.Instance.saveData.boughtItem) {
			this.playerTabHand = new TapHand(this);
			this.shopContainer.add(this.playerTabHand);
			this.alignIn.Center(this.playerTabHand, this.playerTab);
		}
	}

	dismissPlayerTabHand(): void {
		if(this.playerTabHand) {
			this.playerTabHand.destroy();
			this.playerTabHand = null;
		}
	}

	addCharacterButtonHand(): void {
		this.dismissCharacterButtonHand()
		if(PlayerDataUtils.CanUnlockFirstCharacter() && PlayerData.Instance.saveData.boughtItem) {
			this.characterButtonHand = new TapHand(this);
			this.shopContainer.add(this.characterButtonHand)
			this.alignIn.Center(this.characterButtonHand, this.charButtons[1]);
		}
	}

	dismissCharacterButtonHand(): void {
		if(this.characterButtonHand) {
			this.characterButtonHand.destroy();
			this.characterButtonHand = null;
		}
	}

	setCharacter(locked: boolean, index: number): void {
		if (locked) return;

		this.soundManager.play("selectCharacter");
		const newCharacterSelected = PlayerData.Instance.saveData.newCharacterSelected;
		if(index > 0 && (newCharacterSelected == undefined || !newCharacterSelected)) {
			PlayerData.Instance.saveData.newCharacterSelected = true
			this.dismissCharacterButtonHand();
		}
		PlayerData.Instance.saveData.currentCharacter = index;
		PlayerData.Instance.save();
		this.resize();

		const button = this.charButtons[index];
		button.btn.disableInteractive();
		const buttonScale = button.scale;
		const buttonAngle = button.angle;
		const timeline = this.tweens.createTimeline();
		timeline.add({
			targets: button,
			scale: buttonScale * 0.75,
			angle: buttonAngle - 5,
			duration: 75,
			ease: Phaser.Math.Easing.Quadratic.In,
		});

		timeline.add({
			targets: button,
			scale: buttonScale * 1.1,
			angle: buttonAngle + 5,
			duration: 175,
			ease: Phaser.Math.Easing.Quadratic.InOut,
		});

		timeline.add({
			targets: button,
			angle: buttonAngle,
			duration: 100,
			ease: Phaser.Math.Easing.Quadratic.In,
		});

		timeline.add({
			targets: button,
			scale: buttonScale * 0.9,
			// angle: buttonAngle,
			duration: 100,
			ease: Phaser.Math.Easing.Quadratic.InOut,
		});

		timeline.add({
			targets: button,
			scale: buttonScale,
			duration: 80,
			ease: Phaser.Math.Easing.Quadratic.Out,
			onComplete: () => {
				button.btn.setInteractive();
			}
		});

		timeline.play();
	}

	buy(itemName: string, item: StoreItem): void {
		const saveData = PlayerData.Instance.saveData;
		const data = GameConfig.get<any>("items")[itemName] as ItemData;
		const level = saveData.items[itemName];
		if (level >= data.price.length) return;
		const price = data.price[level];
		if (saveData.coins >= price) {
			saveData.coins -= price;
			saveData.items[itemName]++;
			if (itemName == "anvil") {
				if (saveData.slamsUnlocked == undefined) saveData.slamsUnlocked = 0;
				saveData.slamsUnlocked++;
			}
			saveData.boughtItem = true;
			PlayerData.Instance.save();
			this.soundManager.play("purchaseItem");

			const button = item.btn;
			const buttonGroup = item.btnGroup;
			const icon = item.icon;
			button.disableInteractive();
			const buttonGroupScale = buttonGroup.scale;
			const iconAngle = icon.angle;
			const iconTimeline = this.tweens.createTimeline();
			iconTimeline.add({
				targets: icon,
				angle: iconAngle - 2,
				duration: 75,
				ease: Phaser.Math.Easing.Quadratic.In,
			});
			iconTimeline.add({
				targets: icon,
				angle: iconAngle + 3,
				duration: 125,
				ease: Phaser.Math.Easing.Quadratic.InOut,
			});
			iconTimeline.add({
				targets: icon,
				angle: iconAngle,
				duration: 100,
				ease: Phaser.Math.Easing.Quadratic.In,
				onComplete: () => {
					button.setInteractive();
				},
				completeDelay: 180,
			});

			const buttonGroupTimeline = this.tweens.createTimeline();
			buttonGroupTimeline.add({
				targets: buttonGroup,
				scale: buttonGroupScale * 0.8,
				duration: 100,
				onComplete: () => {
					item.updateLayout();
					this.resize();
					this.tweenCoins(price, item);
				}
			});
			buttonGroupTimeline.add({
				targets: buttonGroup,
				scale: buttonGroupScale * 1.1,
				duration: 100,
			});
			buttonGroupTimeline.add({
				targets: buttonGroup,
				scale: buttonGroupScale,
				duration: 100,
			});

			for (let i = 0; i < item.bgs.length; i++) {
				this.tweens.add({
					targets: [item.bgs[i], item.fills[i]],
					y: item.bgs[i].y - 10,
					yoyo: true,
					delay: 50 * i,
					duration: 120,
				});
			}
			iconTimeline.play();
			buttonGroupTimeline.play();	
		}
		else this.soundManager.play("purchaseBlocked");
	}

	tweenCoins(cost: number, target: StoreItem): void {
		const coins = PlayerData.Instance.saveData.coins;
		if (this.costTween) this.costTween.stop();

		const tweenDuration = GameConfig.get("shopCoinTweenDuration") as number;
		const coinCount = GameConfig.get("shopCoinTweenCount") as number;
		const coinFlightDuration = GameConfig.get("shopCoinTravelTime") as number;
		const miniDuration = tweenDuration/coinCount;

		this.costTween = this.tweens.addCounter({
			from: coins + cost,
			to: coins,
			duration: tweenDuration,
		});

		
		let i = 0;
		const updateCoin = (): void => {
			if (!this.itemsVisible) {
				this.coinText.text = PlayerData.Instance.saveData.coins.toLocaleString("en-US");
				this.resizeCoinText();
				return;
			}
			this.coinText.text = Math.ceil(this.costTween.getValue()).toLocaleString("en-US");
			const coinsImg = this.add.image(0, 0, "shopCoin");
			const coinContainer = this.add.container(this.coinContainer.x + this.coinsImg.x, this.coinContainer.y + this.coinsImg.y);
			coinContainer.add(coinsImg);
			this.events.once(ShopScene.HIDE_COINS, () => {
				if (coinsImg) coinsImg.setVisible(false);
			});

			this.tweens.add({
				targets: coinsImg,
				y: -200,
				yoyo: true,
				duration: coinFlightDuration / 2,
				ease: Phaser.Math.Easing.Linear,
			});

			this.tweens.add({
				targets: coinContainer,
				x: this.shopContainer.x + (target.x + target.icon.x) * this.shopContainer.scale,
				y: this.shopContainer.y + (target.y + target.icon.y) * this.shopContainer.scale,
				duration: coinFlightDuration,
				ease: Phaser.Math.Easing.Quadratic.InOut,
				onComplete: () => {
					coinContainer.destroy();
					this.soundManager.play("coinCollect");
					this.tweens.add({
						targets: target.icon,
						scale: {from: 1, to: 1.1},
						yoyo: true,
						ease: Phaser.Math.Easing.Quadratic.Out,
						duration: miniDuration,
					});
				},
			})

			i++;
			if (i < coinCount && this.itemsVisible) this.time.addEvent({delay: miniDuration, callback: () => updateCoin()})
			else this.coinText.text = PlayerData.Instance.saveData.coins.toLocaleString("en-US");
			this.resizeCoinText();
		}

		updateCoin();
	}

	resizeCoinText(): void{
		const defaultSize = 63;
		let yAdjust = -5;
		if(this.coinText.text.length == 4) this.coinText.setFontSize(55);
		else if(this.coinText.text.length >= 5){
			this.coinText.setFontSize(45);
			yAdjust = 0;
		}
		else this.coinText.setFontSize(defaultSize);

		this.alignIn.Center(this.coinText, this.coinsBacker, (this.coinText.width/2) - 10, yAdjust);
	}
	
	back(): void {
		this.scene.start("PreloaderScene", { destinationScene: "SplashScene" });
	}

	toggleSound(btn: Button): void {
		this.soundManager.muted = !this.soundManager.muted;
		this.sound.mute = this.soundManager.muted;
		this.music.muted = !this.music.muted;
		if (!this.soundManager.muted) btn.setTexture("soundButtonOn");
		else btn.setTexture("soundButtonOff");
	}

	play(): void {
		this.scene.start("PreloaderScene", {destinationScene: "GameScene"});
	}

}
